module.exports = __webpack_public_path__ + "static/media/firework2.d3f35d30.gif";